import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Chip,
} from '@mui/material';
import {
  Logout as LogoutIcon,
  Help as HelpIcon,
  VerifiedUser as CertificateIcon,
  Download as DownloadIcon,
  Checklist as ChecklistIcon,
  Group as GroupIcon,
  ExpandMore as ExpandMoreIcon,
  Tune as TuneIcon,
  Science as ScienceIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const AssessorHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [helpMenuAnchor, setHelpMenuAnchor] = useState(null);

  useEffect(() => {
    // Get username from localStorage
    const storedUsername = localStorage.getItem('username') || sessionStorage.getItem('username');
    
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, [location]);

  const handleLogout = () => {
    // Clear user data from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('orgId');
    sessionStorage.clear();
    
    // Redirect to login page
    navigate('/login');
  };

  const handleHelp = () => {
    // Open calibration specific help manual
    window.open('/help/calibration-laboratory', '_blank');
  };

  const handleHelpMenuOpen = (event) => {
    setHelpMenuAnchor(event.currentTarget);
  };

  const handleHelpMenuClose = () => {
    setHelpMenuAnchor(null);
  };

  const handleCreateSubUser = () => {
    handleHelpMenuClose();
    console.log('Create Sub User clicked');
  };

  const handleHelpManual = () => {
    handleHelpMenuClose();
    // Download calibration specific help manual
    const link = document.createElement('a');
    link.href = '/assets/Calibration_Laboratory_Guide.pdf';
    link.download = 'Calibration_Laboratory_Guide.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleChecklist = () => {
    handleHelpMenuClose();
    // Open calibration specific checklist
    window.open('/calibration-checklist.html', '_blank');
  };

  const handleScopeDocuments = () => {
    handleHelpMenuClose();
    // Open scope documents
    window.open('/calibration-scope-documents', '_blank');
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #3b82f6 100%)',
        color: 'white',
        boxShadow: '0 4px 20px rgba(30, 60, 114, 0.3)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ minHeight: 64, px: 0 }}>
          {/* Brand/Logo Section */}
          <Box sx={{ display: 'flex', alignItems: 'center', width:'100%', justifyContent:'space-between', gap:1 }}>
           <div style={{display:'flex', alignItems:'center'}} >
            <TuneIcon 
              sx={{ 
                color: 'white', 
                mr: 1.5, 
                fontSize: 28,
                filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
              }} 
            />
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontWeight: 700,
                color: 'white',
                letterSpacing: '1px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              }}
            >
              NABL - Assessor Dashboard
            </Typography>
            </div>
              <Button
              variant="outlined"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              sx={{
                borderColor: 'rgba(255, 255, 255, 0.5)',
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                },
                transition: 'all 0.3s ease',
                fontWeight: 600,
              }}
            >
              Logout
            </Button>
          </Box>


       
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default AssessorHeader;
